/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const StateLozenge = styled.div`
  margin-top: 1px;
  display: inline-flex;
`;
